export const AppConstants = {
  appBaseUrl: "/crm",
  axiosBaseUrl: "/crm",
  defaultDateFormat: "YYYY-MM-DD",
};
